<template>
  <v-main class="page-library page-library-main">
    <AppBar>
      <template #end>
        <v-btn icon plain :ripple="false" @click="librarySuggestMenu()">
          <IconAppMenu/>
        </v-btn>
      </template>
    </AppBar>
    <LoadImage :aspect-ratio="8/3"
               cover
               :src="$downUrl(recommendedContentsInfo.bannderImgName)"
    />
    <div class="fs-18 fw-500 pa-5">
      {{ recommendedContentsInfo.title }}
    </div>
    <v-divider />
    <div class="fs-14 gray200--text py-4 px-5" v-html="recommendedContentsInfo.contents"></div>
    <hr class="hr" />
    <v-container>
      <div class="library-title-block">
        <h2 class="tit">추천 콘텐츠</h2>
      </div>
      <LibraryItemList :items="recommendedContentsInfo.libNoListInfo"
                       :busy="isLoading"
                       no-data-text="추천 콘텐츠가 없습니다."
      />
    </v-container>
    <!-- 메뉴모달 -->
    <BottomSheet ref="BottomSheet">
      <template #card-body>
        <v-list>
          <v-list-item v-for="(i, index) in recommendedLibList"
                       :key="`btn_${index}`"
                       :ripple="false"
                       color="primary"
                       :to="`/fo/library/suggest/${i.recomContentsId}`"
                       replace>
            <div class="text-truncate">
              {{i.title}}
            </div>
            <v-spacer />
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item>
        </v-list>
      </template>
    </BottomSheet>
  </v-main>
</template>

<script>
import IconAppMenu from "@/components/icons/AppMenu.vue"
import LibraryItemList from './LibraryItemList.vue'
import store from "@/store";
export default {
  name: 'LibrarySuggest',
  components: {
    IconAppMenu,
    LibraryItemList
  },
  data: () => ({
    recommendedContentsInfo: {},
    recommendedLibList: [],
    isLoading: false
  }),
  computed: {
    recomContentsId () {
      return this.$route.params.id
    }
  },
  created () {
    this.getList()
    this.getRecommendedLibList()
  },
  methods: {
    librarySuggestMenu () {
      this.$refs.BottomSheet.open()
    },
    async getList() {
      this.isLoading = true

      // 임시
      await store.dispatch('getRecommendedLibDetail', this.$_payload({'recomContentsId': this.recomContentsId}, {}))
          .then(res => {
            if (res.success) {
              this.recommendedContentsInfo = res.data
            } else {
              this.recommendedContentsInfo = []
            }
          })
          .finally(() => {
             this.isLoading = false
           })
    },
    async getRecommendedLibList() {
        await store.dispatch('getRecommendedLibList', this.$_payload('so', [{subjectLimit: 20}]))
            .then(res => {
              if (res.success) {
                this.recommendedLibList = res.data
              }
            })
      }
  }
}
</script>
